$(document).ready(function () {
    $(".tabs-stage div").hide();
    $(".tabs-stage div:first").show();
    $(".tabs-nav li:first").addClass("tab-active");
  
    $(".tabs-nav a").on("click", function (event) {
      event.preventDefault();
      $(".tabs-nav li").removeClass("tab-active");
      $(this).parent().addClass("tab-active");
      $(".tabs-stage div").hide();
      $($(this).attr("href")).show();
    });
  

    $(".Click-here").on("click", function () {
      $(".custom-model-main").addClass("model-open");
    });
    $(".close-btn, .bg-overlay").click(function () {
      $(".custom-model-main").removeClass("model-open");
    });

  });
  